import { forwardRef } from 'react';
import { MultiSelect } from '@components/MultiSelect';
import { useTranslation } from '@hooks';

const TriggerEventsSelect = forwardRef((props, ref) => {
    const { t } = useTranslation();

    return (
        <MultiSelect
            ref={ref}
            label={t('CampaignsPage.triggerEvent')}
            fullWidth
            countable
            required
            helpTooltip={t('CampaignsPage.triggerExplanation')}
            {...props}
        />
    );
});

TriggerEventsSelect.displayName = 'TriggerEventsSelect';

export default TriggerEventsSelect;
